<ng-container [formGroup]="form">
  <nz-form-item>
    <nz-form-label [nzRequired]="isRequired">
      <p class="form-desc">
        Which of the following best describes the frequency of the behavior?
      </p>
    </nz-form-label>
    <div class="radio-wrapper">
      <nz-radio-group
        id="behaviorFrequency"
        nzName="behaviorFrequency"
        formControlName="behaviourFrequencyId">
        <span
          nz-radio
          *ngFor="let freq of behaviourFrequencyList; trackBy: trackById"
          [nzValue]="freq.id"
          class="box-radio">
          {{ getBehaviorFrequencyLabel(freq.name) }}
        </span>
      </nz-radio-group>
    </div>
    <div
      class="ant-form-item-explain-error mt-3"
      *ngIf="form.get('behaviourFrequencyId')?.hasError('required')">
      Please select Frequency of the behavior.
    </div>
  </nz-form-item>
  <nz-divider />
  <nz-form-item>
    <nz-form-label nzFor="occurrence" [nzRequired]="isRequired">
      On average how many times does the behavior occur?
    </nz-form-label>
    <nz-form-control>
      <input
        id="occurrence"
        name="occurrence"
        type="text"
        aria-label="On average how many times does the behavior occur?"
        nz-input
        formControlName="behaviourFrequencyCount"
        placeholder="Enter occurrence" />
      <div
        class="ant-form-item-explain-error mt-3"
        *ngIf="form.get('behaviourFrequencyCount')?.hasError('required')">
        Please enter behavior occurrence.
      </div>
      <div
        class="ant-form-item-explain-error mt-3"
        *ngIf="form.get('behaviourFrequencyCount')?.hasError('pattern')">
        Behavior frequency count only allows numbers (decimals allowed).
      </div>
    </nz-form-control>
  </nz-form-item>
  <nz-divider />
  <nz-form-item>
    <nz-form-label [nzRequired]="isRequired">
      <p class="form-desc">
        Once the behavior starts, how long does it usually last?
      </p>
    </nz-form-label>
    <div class="radio-wrapper">
      <nz-radio-group
        id="isDurationRequired"
        nzName="isDurationRequired"
        formControlName="isDurationRequired">
        <span nz-radio [nzValue]="false" class="box-radio">
          Duration does not matter or is instantaneous
        </span>
        <span nz-radio [nzValue]="true" class="box-radio"> Minutes </span>
      </nz-radio-group>
    </div>
  </nz-form-item>
  <div
    class="form-grid-secondary"
    *ngIf="form.get('isDurationRequired')?.value === true">
    <nz-form-item>
      <nz-form-label
        nzFor="minutes"
        [nzRequired]="
          form.get('isDurationRequired')?.value === true && isRequired
        ">
        Duration
      </nz-form-label>
      <nz-form-control>
        <input
          id="minutes"
          name="minutes"
          type="text"
          aria-label="Duration"
          nz-input
          formControlName="duration"
          placeholder="Enter duration" />
        <div
          class="ant-form-item-explain-error mt-3"
          *ngIf="form.get('duration')?.hasError('required')">
          Please enter the duration of the behavior.
        </div>
        <div
          class="ant-form-item-explain-error mt-3"
          *ngIf="form.get('duration')?.hasError('pattern')">
          Duration only allows numbers.
        </div>
      </nz-form-control>
    </nz-form-item>
  </div>
</ng-container>
